import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RentReservationService } from '../../../core/services/rent-reservation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { FleetService } from '../../../core/services/fleet.service';

@Component({
  selector: 'app-current-fuel-and-mileage-update-popup',
  templateUrl: './current-fuel-and-mileage-update-popup.component.html',
  styleUrls: ['./current-fuel-and-mileage-update-popup.component.scss'],
})
export class CurrentFuelAndMileageUpdatePopupComponent implements OnInit {
  //Current Fuel and Mileage Update Stuff
  @Output() currentFuelAndMileageUpdateOnChange: EventEmitter<any> =
    new EventEmitter();
  @Input() isVisibleFuelAndMileageUpdate = false;

  fuelLevel: any = 0;
  mileage: any = 0;
  selectedFleet: any;
  isLoading = false;
  index = 0;

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private fleetService: FleetService,
    private messages: NzMessageService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.fleetService.selectedFleet.subscribe((res: string) => {
      this.selectedFleet = res;
    });
  }

  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.currentFuelAndMileageUpdateOnChange.emit({
      name: 'isVisible',
      value: false,
    });
    this.fuelLevel = 0;
    this.mileage = 0;
    this.fleetService.selectedFleet.next('');
  }

  handleOkUpdateFuelAndMileage(type: string): void {
    if (type === 'with') {
      this.isLoading = true;
      this.fleetService
        .updateFleet({
          _id: this.selectedFleet,
          currentMileage: this.mileage,
          currentFuelLevel: this.fuelLevel,
          status: 'ON_RENT',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.isVisibleFuelAndMileageUpdate = false;
            this.currentFuelAndMileageUpdateOnChange.emit({
              name: 'done',
              value: false,
            });
            this.fleetService.selectedFleet.next('');
            this.fuelLevel = 0;
            this.mileage = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    } else {
      this.isVisibleFuelAndMileageUpdate = false;
      this.currentFuelAndMileageUpdateOnChange.emit({
        name: 'done',
        value: false,
      });
      this.fleetService.selectedFleet.next('');
      this.fuelLevel = 0;
      this.mileage = 0;
    }
  }
}
